export const AddNewMachineButton = 'mt-5 w-full md:w-1/3 mt-4'

export const ButtonWrapper =
  'font-Roboto text-10 leading-12 tracking-0 cursor-pointer uppercase w-fit w-moz-fit pb-4 md:pb-6 last-of-type:pb-0 hover:text-accentYellow transition select-none'

export const ButtonUnderline = `after:mt-1 after:block after:content-[''] after:w-[calc(100%-0.188rem)] after:border-b`

export const ConfirmationHeadline = 'text-black'

export const ConfirmationButtonsWrapper = 'flex w-full pt-8'

export const ConfirmationCancelButton = 'mr-2'

export const ErrorMessageWrapper = 'text-errorRed text-14 pt-6 pb-4'

export const FormFieldsWrapper = 'flex flex-col py-4'

export const FormFieldItem = 'mt-4'

export const AlertBoxWrapper = 'md:w-full'

export const OrSeparator = 'text-grayRegular py-4 text-center'

export const RegisterableMachinesSelectBox = 'w-full'
